import React, { useEffect, useState } from "react";
import SingleCard from "../../../Components/Admin/SingleCard/SingleCard";
import { FaCity, FaUsers } from "react-icons/fa";
import { GiGiftOfKnowledge } from "react-icons/gi";
import api from "../../../configs/api";
import Loader from "../../../common/Loader";

const Home = () => {
  const [loading, setLoading] = useState(false);

  const [counts, setCounts] = useState({
    totalUsers: {
      title: "Total Users",
      totalNumber: 0,
      icon: FaUsers,
    },
    totalSpecialist: {
      title: "Total Specialist",
      totalNumber: 0,
      icon: FaUsers,
    },
    averageExperience: {
      title: "Average Experience",
      totalNumber: 0,
      icon: GiGiftOfKnowledge,
    },
    TotalCities: {
      title: "Most popular",
      cityName: "",
      icon: FaCity,
    },
  });

  async function getCount() {
    setLoading(true);
    try {
      const res = await api.get(`admin/get_all_counts`);

      setCounts({
        totalUsers: {
          title: "Total Users",
          totalNumber: res.data.users,
          icon: FaUsers,
        },
        totalSpecialist: {
          title: "Total Specialist",
          totalNumber: res.data.specialists,
          icon: FaUsers,
        },
        averageExperience: {
          title: "Experience avg",
          totalNumber: Math.ceil(res.data.avgYearsOfExperience),
          icon: GiGiftOfKnowledge,
        },
        TotalCities: {
          title: "Most popular",
          totalNumber: res.data.mostSpecialistCity,
          icon: FaCity,
        },
      });
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  }

  useEffect(() => {
    getCount();
  }, []);

  return (
    <div className='bg-[#FAFAFA] min-h-screen flex justify-center'>
      {loading ? (
        <Loader />
      ) : (
        <div className='my-10 bg-[#FFFFFF] flex flex-col flex-wrap p-10'>
          <h1 className='text-[#193548] mb-4'>General Stats</h1>
          <div className='flex flex-wrap justify-center gap-6'>
            <SingleCard item={counts?.averageExperience} />
            <SingleCard item={counts?.TotalCities} />
            <SingleCard item={counts?.totalUsers} />
            <SingleCard item={counts?.totalSpecialist} />
          </div>
        </div>
      )}
    </div>
  );
};

export default Home;
